import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { EmptyState, money, fmtDate } from "@/components/common";
import { ConsolidateOrdersButton } from "@/components/ConsolidateOrdersDialog";
import { MagnifyingGlass } from "@phosphor-icons/react";

export function ConsolidatedRegister({ isTeam }) {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  useEffect(() => { api.get("/consolidated-invoices").then((r) => setRows(r.data || [])).catch(() => { setRows([]); toast.error("Could not load consolidated invoices"); }); }, []);
  const s = q.trim().toLowerCase();
  const filtered = useMemo(() => (rows || []).filter((r) => (!from || r.issued_date.slice(0, 10) >= from) && (!to || r.issued_date.slice(0, 10) <= to) &&
    (!s || [r.number, r.client_name, r.created_by, ...(r.order_numbers || [])].some((v) => (v || "").toLowerCase().includes(s)))), [rows, s, from, to]);
  return (
    <div className="space-y-4" data-testid="consolidated-register">
      <div className="flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-[220px]"><MagnifyingGlass size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" /><Input className="pl-9 rounded-sm" placeholder="Search CINV number, client, order…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="consolidated-search" /></div>
        <Input type="date" className="rounded-sm w-36" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="consolidated-from" />
        <Input type="date" className="rounded-sm w-36" value={to} onChange={(e) => setTo(e.target.value)} data-testid="consolidated-to" />
        <ConsolidateOrdersButton variant="default" />
      </div>
      {rows === null ? <p className="text-sm text-muted-foreground">Loading…</p> : filtered.length === 0 ? <EmptyState title="No consolidated invoices" hint="Use “Consolidate invoices” to group several orders into one payment request." /> : (
        <div className="border border-border rounded-md overflow-x-auto bg-card">
          <table className="w-full text-sm" data-testid="consolidated-table">
            <thead><tr className="text-left text-xs uppercase tracking-wider font-semibold text-muted-foreground bg-muted/40"><th className="px-4 py-3">Number</th><th className="px-4 py-3">Date</th>{isTeam && <th className="px-4 py-3">Client</th>}<th className="px-4 py-3">Orders</th><th className="px-4 py-3 text-right">Total requested</th><th className="px-4 py-3">Created by</th></tr></thead>
            <tbody>{filtered.map((r, i) => (
              <tr key={r.id} className={`border-t border-border hover:bg-primary/5 ${i % 2 ? "bg-muted/30" : ""}`} data-testid={`consolidated-row-${r.number}`}>
                <td className="px-4 py-3 font-medium"><Link to={`/consolidated-invoices/${r.id}`} className="text-primary hover:underline">{r.number}</Link></td>
                <td className="px-4 py-3">{fmtDate(r.issued_date)}</td>
                {isTeam && <td className="px-4 py-3">{r.client_name}</td>}
                <td className="px-4 py-3 text-muted-foreground" title={(r.order_numbers || []).join(", ")}>{r.order_numbers?.length} · {(r.order_numbers || []).slice(0, 3).join(", ")}{r.order_numbers?.length > 3 ? "…" : ""}</td>
                <td className="px-4 py-3 text-right font-semibold tabular-nums">{money(r.grand_total)}</td>
                <td className="px-4 py-3 text-muted-foreground">{r.created_by}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
